export default {
  capricorn: require('./capricorn').default,
  flutterwave: require('./flutterwave').default,
};
